// ShippingLabelPDF.js
import React, { useEffect, useState } from 'react';
import middleware from '../Api/Middleware';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import JsBarcode from 'jsbarcode';
import { PDFstyle } from './Components/LabelPDFstyling';
// import { BarcodeGenerator } from './BarcodeGenerator'; // You would need to implement this

// Define styles
const styles = StyleSheet.create(PDFstyle);

// Create Document Component
const ShippingLabelPDF = ({ barcodeURL, companyAddress, deliveryAddress, customer, size = 'A5', orientation = 'landscape' }) => {

    return (
        <Document>
            <Page size={[283, 425]} orientation={orientation} style={styles.page}>
                {/* Header section */}
                <View style={styles.afzenderSection}>
                    <Text style={styles.smallText}>Afzender:</Text>
                    <Text style={styles.text}>{companyAddress.company_name}</Text>
                    <Text style={styles.text}>{companyAddress.street_name} {companyAddress.house_number}{companyAddress.addition ? ` - ${companyAddress.addition}` : ''}</Text>
                    <Text style={styles.text}>{companyAddress.postal_code} {companyAddress.city}</Text>
                </View>
                <View style={styles.middleHeaderSection}>
                    <Text style={styles.boldText}>Verzonden via {companyAddress.company_name}</Text>
                </View>
                <Text style={styles.addressTextSection}>
                    <Text style={styles.addressText}>{companyAddress.company_name}</Text>
                    {/* <Text style={styles.AVGtext}>AVG</Text> */}
                </Text> 
                <View style={styles.addressBox}>
                    {customer.company_name
                        ? <Text style={styles.text2}>{customer.company_name}</Text>
                        : <Text style={styles.text2}>{customer.first_name} {customer.last_name}</Text>
                    }
                    {deliveryAddress ? (
                        <>
                            <Text style={styles.text2}>{deliveryAddress?.streetname} {deliveryAddress?.housenumber}{deliveryAddress.addition ? ` - ${deliveryAddress.addition}` : ''}</Text>
                            <Text style={styles.text2}>{deliveryAddress?.postalcode} {deliveryAddress?.city}</Text>
                        </>
                    ) : (
                        <Text style={styles.text2}>Geen bezorgadres geselecteerd</Text>
                    )}
                </View>
                <View style={styles.colloBox}>
                    <Text style={styles.collo}>1 Collo</Text>
                </View>
                <View style={styles.barcodeSection}>
                    <Image src={barcodeURL} />
                </View>
            </Page>
        </Document>
    )
};

export default ShippingLabelPDF;